const CARD_ROUTES = [
  '/en/zurichcard/buy-online',
  '/de/zuerichcard/online-kaufen',
  '/fr/zurichcard/acheter-en-ligne',
  '/it/zurichcard/acquisto-online',
  '/es/zurichcard/comprar-online',
]

export default defineNuxtRouteMiddleware((to) => {
  const language = to.path.split('/')[1] || 'en'

  for (const route of CARD_ROUTES) {
    if (to.path.includes(route)) {
      return navigateTo(`/card-shop?l=${language}`, {
        external: true,
      })
    }
  }
})
